import { post,put,del,get } from './axios'

export const getNoticeDetail = async (params) => {
  const { status, data } = await get("/notice/selectNoticeDetailAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const noticeList = async (params) => {
  const { status, data } = await get("/notice/selectNoticeAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const updateViewCount = async (params) => {
  const { status, data } = await post("/notice/updateViewCountAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}